function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 70,
  fill: "#EDEDED",
  width: 110,
  height: 141.431
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 70,
  y: 37,
  fill: "#ED92C8",
  width: 110,
  height: 18.86
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 82.57,
  y: 13.43,
  fill: "#333333",
  width: 84.859,
  height: 12.57
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 82.57,
  y: 66.86,
  fill: "#919191",
  width: 84.859,
  height: 9.43
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 82.57,
  y: 88.86,
  fill: "#919191",
  width: 84.859,
  height: 9.43
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 82.57,
  y: 110.86,
  fill: "#919191",
  width: 84.859,
  height: 9.43
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  y: 49.431,
  fill: "#00ADC0",
  width: 100,
  height: 100
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 7.5,
  y: 69.431,
  fill: "#FFFFFF",
  width: 85,
  height: 72.5
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  y: 49.431,
  fill: "#008F9E",
  width: 100,
  height: 20
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 12.5,
  y: 76.931,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 32.5,
  y: 76.931,
  fill: "#D5007F",
  width: 15,
  height: 15
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 72.5,
  y: 76.931,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 52.5,
  y: 76.931,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 12.5,
  y: 99.431,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 32.5,
  y: 99.431,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 72.5,
  y: 99.431,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 52.5,
  y: 99.431,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 12.5,
  y: 121.931,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 32.5,
  y: 121.931,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 72.5,
  y: 121.931,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 52.5,
  y: 121.931,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref23 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 80,
  cy: 59.431,
  r: 3.75
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 20,
  cy: 59.431,
  r: 3.75
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 220,
  y: 62,
  fill: "#EDEDED",
  width: 100,
  height: 130
});

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 220,
  y: 62,
  fill: "#929292",
  width: 100,
  height: 17
});

var _ref27 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 230,
  y: 94,
  fill: "#929292",
  width: 80,
  height: 10
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 230,
  y: 114,
  fill: "#929292",
  width: 80,
  height: 10
});

var _ref29 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 230,
  y: 134,
  fill: "#929292",
  width: 80,
  height: 10
});

var _ref30 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 240,
  y: 167,
  fill: "#929292",
  width: 60,
  height: 5
});

var _ref31 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 150,
  y: 112,
  fill: "#00ADC0",
  width: 100,
  height: 100
});

var _ref32 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 157.5,
  y: 132,
  fill: "#FFFFFF",
  width: 85,
  height: 72.5
});

var _ref33 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 150,
  y: 112,
  fill: "#008F9E",
  width: 100,
  height: 20
});

var _ref34 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 162.5,
  y: 139.5,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref35 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 182.5,
  y: 139.5,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref36 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 222.5,
  y: 139.5,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref37 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 202.5,
  y: 139.5,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref38 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 162.5,
  y: 162,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref39 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 182.5,
  y: 162,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref40 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 222.5,
  y: 162,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref41 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 202.5,
  y: 162,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref42 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 162.5,
  y: 184.5,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref43 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 182.5,
  y: 184.5,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref44 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 222.5,
  y: 184.5,
  fill: "#BCF0F6",
  width: 15,
  height: 15
});

var _ref45 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 202.5,
  y: 184.5,
  fill: "#D5007F",
  width: 15,
  height: 15
});

var _ref46 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 230,
  cy: 122,
  r: 3.75
});

var _ref47 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 170,
  cy: 122,
  r: 3.75
});

var SvgQueEsObs03 = function SvgQueEsObs03(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "320px",
    height: "212px",
    viewBox: "0 0 320 212",
    enableBackground: "new 0 0 320 212",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQueEsObs03, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/queEsObs_03.5bfcce9d.svg";
export { ForwardRef as ReactComponent };